module.exports = __webpack_public_path__ + "static/media/slide3_mobile_small.ce43a561.jpg";